/*
 * @Author: Ryan
 * @Date: 2026-01-22
 * @Description: 原生 Button 组件 - 用于 Landing 页面，避免引入 antd
 */
import React from 'react';

import styles from './index.module.scss';

export type ButtonVariant = 'primary' | 'text' | 'default';
export type NativeButtonType = 'button' | 'submit' | 'reset';

export interface NativeButtonProps extends Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  'type'
> {
  /** 按钮样式类型（模拟 antd 的 type） */
  type?: ButtonVariant;
  /** 原生 button type 属性 */
  htmlType?: NativeButtonType;
  /** 自定义类名 */
  className?: string;
  /** 子元素 */
  children?: React.ReactNode;
}

const NativeButton: React.FC<NativeButtonProps> = ({
  type = 'default',
  htmlType = 'button',
  className = '',
  children,
  ...restProps
}) => {
  const typeClass = styles[type] || styles.default;

  return (
    <button
      type={htmlType}
      className={`${styles.button} ${typeClass} ${className}`.trim()}
      {...restProps}
    >
      {children}
    </button>
  );
};

export default NativeButton;
